import React, { useState } from 'react';
import Button from '../Button';
import Dialog from './Dialog';
import ShipmentSearchPicker from './ShipmentSearchPicker';

// "Přiřadit k zásilce": choose the shipment an unlinked e-mail belongs to.
const ReviewLinkDialog = ({ onClose, onSubmit, busy }) => {
  const [target, setTarget] = useState(null);
  return (
    <Dialog
      title="Přiřadit e-mail k zásilce" busy={busy} onClose={onClose}
      footer={(
        <>
          <Button variant="secondary" onClick={onClose} disabled={busy}>Zrušit</Button>
          <Button disabled={!target} loading={busy} onClick={() => onSubmit(target)}>Přiřadit</Button>
        </>
      )}
    >
      <div style={{ paddingBottom: 8 }}><ShipmentSearchPicker value={target} onChange={setTarget} /></div>
    </Dialog>
  );
};

export default ReviewLinkDialog;
